export const CONSENT_KEY = "we-cookie-consent";
const CONSENT_VALUES = new Set(["accepted", "rejected"]);

// This preference contains no identity, credentials, tokens, or personal data.
export const getConsent = () => {
  try {
    const value = window.localStorage.getItem(CONSENT_KEY);
    return CONSENT_VALUES.has(value) ? value : null;
  } catch {
    console.warn("[WebEssence] No se pudo leer la preferencia de cookies; se solicitará de nuevo.");
    return null;
  }
};

export const saveConsent = (value) => {
  if (!CONSENT_VALUES.has(value)) throw new TypeError("Preferencia de cookies no válida");
  try {
    window.localStorage.setItem(CONSENT_KEY, value);
    return true;
  } catch {
    console.warn("[WebEssence] No se pudo guardar la preferencia de cookies; solo se aplicará durante esta visita.");
    return false;
  }
};